import React, { Component } from 'react'
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import '../css/Footer.css'
import '.././App.css';

class VehicleHealthComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (

            <div>


                <section id="multiple-column-form mt-3">
                    <div className="row match-height p-0  m-0">
                        <div className="col-12 p-0">
                            <div className="card p-0">

                                <div className="card-content">
                                    <div className="card-body p-0"></div>
                                    {/* <form className="form" onSubmit={this.submitHandler} > */}
                                        <div className="form-body">
                                            <div className="row p-0 m-0">




                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="date" id="email" name="email" className="form-control" />
                                                        <label htmlFor="city-column">Pick date of last {this.props.Activity} </label>
                                                    </div>
                                                </div>

{/* 
                                                <div className="col-md-12 col-12">
                                                    <h6 className="pull-left">Set Alert Type</h6>
                                                </div>

                                                <div className="col-md-3 col-12">
                                                    <div className="form-group d-flex justify-content-between align-items-center">
                                                        <div className="text-left">
                                                            <fieldset className="checkbox">
                                                                <div className="vs-checkbox-con vs-checkbox-shell">
                                                                    <input type="checkbox" />
                                                                    <span className="vs-checkbox">
                                                                        <span className="vs-checkbox--check">
                                                                        </span>
                                                                    </span>
                                                                    <span className>Email to this user</span>
                                                                </div>
                                                            </fieldset>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="col-md-3 col-12">
                                                    <div className="form-group d-flex justify-content-between align-items-center">
                                                        <div className="text-left">
                                                            <fieldset className="checkbox">
                                                                <div className="vs-checkbox-con vs-checkbox-shell">
                                                                    <input type="checkbox" />
                                                                    <span className="vs-checkbox">
                                                                        <span className="vs-checkbox--check">
                                                                        </span>
                                                                    </span>
                                                                    <span className>SMS alert to this user </span>
                                                                </div>
                                                            </fieldset>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="col-md-3 col-12">
                                                    <div className="form-group d-flex justify-content-between align-items-center">
                                                        <div className="text-left">
                                                            <fieldset className="checkbox">
                                                                <div className="vs-checkbox-con vs-checkbox-shell">
                                                                    <input type="checkbox" />
                                                                    <span className="vs-checkbox">
                                                                        <span className="vs-checkbox--check">
                                                                        </span>
                                                                    </span>
                                                                    <span className>Display on this portal </span>
                                                                </div>
                                                            </fieldset>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="text" id="email" name="email" className="form-control" />
                                                        <label htmlFor="city-column">Enter alternate email address</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="text" id="email" name="email" className="form-control" />
                                                        <label htmlFor="city-column">Enter alternate mobile number</label>
                                                    </div>
                                                </div>
                                                    
                                                <div className="col-12" style={{ textAlign: 'center' }}>
                                                    <button type="submit" className="btn btn-shell mr-1 mb-1">Confirm</button>
                                                </div>*/}
                                            </div>
                                        </div>
                                    {/* </form> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </section>



            </div>


        );

    }

}


export default VehicleHealthComponent;